import * as axios from "axios/dist/axios.min";

export class WPApi {

    baseUrl = `${location.origin}/wp-json/`;

    async request(endpoint, method = 'GET', data = null, headers = null) {

        const url = `${this.baseUrl}${endpoint}`;


        const options = {
            url,
            method: method.toLowerCase(),
            json: true,
        };

        if (!headers) {
            headers = {};
        }

        headers['Content-Type'] = 'application/json';

        if (!headers.hasOwnProperty('x-sport1-mobile-app')) {
            headers['x-sport1-mobile-app'] = true;
        }

        options.headers = headers;

        if (data) {
            options.data = data;
        }

        return await axios(options).then(response => {
            return response.data;
        });
    }

    async get(endpoint,headers = null) {
        return this.request(endpoint,'GET',null,headers);
    }

    async post(endpoint, data, headers = null) {
        return this.request(endpoint, 'POST', data, headers);
    }


    async delete(endpoint) {
        return this.request(endpoint, 'DELETE');
    }


    async put(endpoint) {
        return this.request(endpoint, 'PUT');
    }
}
